import React from 'react';

import { useIntl } from 'react-intl';
import { useRouterActions } from 'react-resource-router';

import { cssMap } from '@atlaskit/css';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';
import { useHubTheming } from '@atlassian/company-hub-common/hub-theming-context';
import { useHubContext } from '@atlassian/company-hub-common/utils';

import { messages } from './messages';

const styles = cssMap({
	container: {
		paddingTop: token('space.100'),
		paddingRight: token('space.200'),
		paddingLeft: token('space.250'),
	},
	link: {
		color: token('color.link'),
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
});

export const ShowMoreLink = ({ queryWord }: { queryWord: string }): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { push } = useRouterActions();
	const {
		env: { relativeBaseUrl },
	} = useHubContext();
	const primaryLinkColor = useHubTheming()?.primaryLinkColor;

	const brandedLinkStyle = primaryLinkColor ? { color: primaryLinkColor } : undefined;

	const searchPath = `/articles/search?q=${encodeURIComponent(queryWord)}`;
	const href = `${relativeBaseUrl.replace(/\/+$/, '')}${searchPath}`;

	const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		if (
			event.defaultPrevented ||
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.altKey ||
			event.shiftKey
		) {
			return;
		}
		event.preventDefault();
		push(searchPath);
	};

	return (
		<Box xcss={styles.container}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- tenant brand colour is only known at runtime */}
			<Anchor href={href} onClick={onClick} style={brandedLinkStyle} xcss={styles.link}>
				{formatMessage(messages.showMore)}
			</Anchor>
		</Box>
	);
};
